import { type IItem, type ICollectionParams, type IResourceParams, type IList, type IBaseDataProvider } from './models';
import { EventEmitter } from '../classes';
import { CollectionResource, ItemResource } from './resource';

export abstract class AbstractCollectionDataProvider<T extends IItem> extends EventEmitter implements IBaseDataProvider {
    protected data = [];

    public getCollectionResource(resourceParams: IResourceParams = {}, debug: boolean = false): CollectionResource<T> {
        return new CollectionResource<T>(this, resourceParams, this.getResourceUrl(resourceParams), debug);
    }

    public abstract list(collectionParams: ICollectionParams, resourceParams?: IResourceParams, timeout?: Promise<void>): Promise<IList<T>>;

    // emulation

    public get(): Promise<T> {
        return Promise.reject('method is not implemented');
    }

    public update(): Promise<T> {
        return Promise.reject('method is not implemented');
    }

    public patch(): Promise<T> {
        return Promise.reject('method is not implemented');
    }

    public add(): Promise<T> {
        return Promise.reject('method is not implemented');
    }

    public remove(): Promise<any> {
        return Promise.reject('method is not implemented');
    }

    public getItemResource(resourceParams: IResourceParams): ItemResource<T> {
        return new ItemResource<T>(this, resourceParams, this.getResourceUrl(resourceParams));
    }

    public isError(): boolean {
        return false;
    }

    public getErrorMessage(): string {
        return undefined;
    }

    public getPageNames(): Promise<any> {
        return Promise.resolve({});
    }

    protected abstract getResourceUrl(resourceParams?: IResourceParams): string;
}
